export class KbcUlsterModalActionsVm {
    constructor() { }

    customAction?: () => any;
    customCloseAction!: () => any;
    inputs: any;
}